import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Mail, Phone, MapPin, User } from "lucide-react";

export default function Contact() {
  const [c, setC] = useState({ agent_name: "", email: "", phone: "", address: "" });

  useEffect(() => {
    api.get("/contact").then((r) => setC(r.data || {}));
  }, []);

  return (
    <div className="mx-auto max-w-4xl px-4 py-10 sm:px-6 lg:px-8">
      <header className="mb-8">
        <div className="text-xs font-mono uppercase tracking-widest text-stone-500">Managing Agent</div>
        <h1 className="mt-1 font-serif text-4xl font-semibold text-stone-900 sm:text-5xl">Contact details</h1>
        <p className="mt-2 text-stone-600">
          Get in touch with the appointed Managing Agent for enquiries, maintenance, or emergencies.
        </p>
      </header>

      <div className="rounded-3xl border border-stone-200 bg-white p-6 sm:p-10 shadow-sm">
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
          <InfoCard icon={<User className="h-5 w-5" />} label="Managing Agent" value={c.agent_name} />
          <InfoCard
            icon={<Mail className="h-5 w-5" />}
            label="Email"
            value={c.email}
            href={c.email ? `mailto:${c.email}` : null}
            testid="contact-email"
          />
          <InfoCard
            icon={<Phone className="h-5 w-5" />}
            label="Telephone"
            value={c.phone}
            href={c.phone ? `tel:${c.phone}` : null}
            testid="contact-phone"
          />
          <InfoCard icon={<MapPin className="h-5 w-5" />} label="Address" value={c.address} />
        </div>
      </div>
    </div>
  );
}

function InfoCard({ icon, label, value, href, testid }) {
  if (!value) return null;
  const Wrapper = ({ children }) =>
    href ? (
      <a href={href} data-testid={testid} className="block">
        {children}
      </a>
    ) : (
      <div>{children}</div>
    );
  return (
    <Wrapper>
      <div className="group rounded-2xl border border-stone-200 bg-stone-50/60 p-5 transition hover:bg-amber-50/60">
        <div className="flex items-center gap-2 text-xs font-mono uppercase tracking-widest text-stone-500">
          {icon}
          {label}
        </div>
        <div className="mt-2 text-lg font-medium text-stone-900 group-hover:text-amber-900">{value}</div>
      </div>
    </Wrapper>
  );
}
